import { Table, TableColumnGroupHeader, TableColumnHeader, TableRow } from '@/common'
import useI18n from '@/shared/hooks/usei18n'
import CbamSimulationRow from './CbamSimulationRow'
export default function CbamSimulationsTable({
  simulationIds,
  onDeleteSimulation
}: {
  simulationIds: string[]
  onDeleteSimulation: (simulationId: string) => void
}) {
  const { t } = useI18n()

  return (
    <Table>
      <thead>
        <TableRow>
          <TableColumnHeader className="w-36" />
          <TableColumnHeader className="w-12" />
          <TableColumnHeader className="w-36" />
          <TableColumnHeader className="w-36" />
          <TableColumnHeader className="w-36" />
          <TableColumnGroupHeader colSpan={3}>
            {t(
              'cbamSimulations:cbamSimulationsPage.cbamSimulationsTable.headers.estimatedLiability'
            )}
          </TableColumnGroupHeader>
        </TableRow>
        <TableRow>
          <TableColumnHeader className="w-28">
            {t('cbamSimulations:cbamSimulationsPage.cbamSimulationsTable.headers.simulationName')}
          </TableColumnHeader>
          <TableColumnHeader className="w-28">
            {t('cbamSimulations:cbamSimulationsPage.cbamSimulationsTable.headers.volume')}
          </TableColumnHeader>
          <TableColumnHeader className="w-28" align="right">
            {t(
              'cbamSimulations:cbamSimulationsPage.cbamSimulationsTable.headers.totalDirectEmbeddedEmissions'
            )}
          </TableColumnHeader>
          <TableColumnHeader className="w-28" align="right">
            {t(
              'cbamSimulations:cbamSimulationsPage.cbamSimulationsTable.headers.totalIndirectEmbeddedEmissions'
            )}
          </TableColumnHeader>
          <TableColumnHeader className="w-28" align="right">
            {t('cbamSimulations:cbamSimulationsPage.cbamSimulationsTable.headers.totalEmissions')}
          </TableColumnHeader>
          <TableColumnHeader className="w-28" align="right">
            {t('cbamSimulations:cbamSimulationsPage.cbamSimulationsTable.headers.liability2026')}
          </TableColumnHeader>
          <TableColumnHeader className="w-28" align="right">
            {t(
              'cbamSimulations:cbamSimulationsPage.cbamSimulationsTable.headers.liability2026HigherImpact'
            )}
          </TableColumnHeader>
          <TableColumnHeader className="w-28" align="right">
            {t(
              'cbamSimulations:cbamSimulationsPage.cbamSimulationsTable.headers.liability2026LowerImpact'
            )}
          </TableColumnHeader>
          <TableColumnHeader className="w-28" />
        </TableRow>
      </thead>
      <tbody>
        {simulationIds.map(simulationId => (
          <CbamSimulationRow
            key={simulationId}
            simulationId={simulationId}
            onDeleteSimulation={onDeleteSimulation}
          />
        ))}
      </tbody>
    </Table>
  )
}
